import { render } from "./chatRoomList.vue?vue&type=template&id=09631cac"
import script from "./chatRoomList.vue?vue&type=script&lang=js"
export * from "./chatRoomList.vue?vue&type=script&lang=js"

import "./chatRoomList.vue?vue&type=style&index=0&id=09631cac&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__